import React from "react";
import "./ClassProgress.css";
import AboutTeacher from "../AboutTeacher/AboutTeacher";
import LevelClass from "../LevelClass/LevelClass";

// Helper function to format duration from seconds
const formatDuration = (durationInSeconds) => {
  const hours = Math.floor(durationInSeconds / 3600); // Convert seconds to hours
  const minutes = Math.floor((durationInSeconds % 3600) / 60); // Convert remaining seconds to minutes
  const seconds = Math.round(durationInSeconds % 60); // Get remaining seconds
  return `${hours}h ${minutes}m ${seconds}s`;
};

function ClassProgress({ progress, subtopics = [], duration, instructor, instructor_title, about_teacher, education_class, enrolled, views }) {
  // Format the duration before rendering
  const formattedDuration = formatDuration(duration);

  return (
    <div className="class-progress-container">
    <div className="class-progress-bar">
      <div className="lesson-hour">
        <span className="progress-text">{subtopics.length} Lessons</span>
        <span className="progress-text">{formattedDuration}</span> {/* Display formatted duration */}
      </div>
      <div className="progress-line">
        <div className="progressBar" />
        <span className="progress-text">{Math.round(progress)}%</span>
      </div>
    </div>
    <AboutTeacher 
        about_teacher={about_teacher}
        instructor={instructor}
        instructor_title={instructor_title}/>
    <LevelClass 
      education_class={education_class}
      enrolled={enrolled}
      views={views}
      />
    </div>
  );
}

export default ClassProgress;